import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email, digits } from "vee-validate/dist/rules";
import VueApexCharts from "vue-apexcharts";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Paginate from "vuejs-paginate";
import BlockUI from "vue-blockui";

Vue.use(BlockUI);

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";

Vue.component("v-select", vSelect);

extend("email", {
  ...email,
  message: "Invalid Email ID ",
});
extend("required", {
  ...required,
  message: "This field is required",
});
extend("phone", {
  ...digits,
  message: "Phone Number Length should be 10",
});

extend("digits", digits);

// Register it globally
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.filter("formatDate", (val) => {
  let date = val.substring(0, 10).split("-");
  return date[2] + "/" + date[1] + "/" + date[0];
});
window.axios = axios;

Vue.component("paginate", Paginate);

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
if (
  process.env.VUE_APP_API_URL == "" ||
  process.env.VUE_APP_API_URL == undefined
) {
  alert("PLEASE SETUP VUE_API_URL in the env");
  process.exit(1);
}
const createApiClient = (baseURL) => {
  const instance = axios.create({
    baseURL,
    timeout: 10000,
    headers: { "Content-Type": "application/json" },
  });
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token") || store?.getters?.getToken;
      if (token) {
        config.headers["Authorization"] = token;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.request.use(
    (config) => {
      const token = store.getters.getToken; // Fetch the token from your store

      if (token) {
        config.headers["Authorization"] = `${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};

// Create your two API clients
// export const apiV1 = createApiClient(process.env.VUE_APP_API_URL);
export const apiV2 = createApiClient(process.env.VUE_APP_API_V3_URL);

// Register globally (add these two lines)
// Vue.prototype.$apiV1 = apiV1;
Vue.prototype.$apiV2 = apiV2;
axios.interceptors.request.use(
  (config) => {
    const token = store.getters.getToken;

    if (token) {
      config.headers["Authorization"] = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(require("vue-moment"));

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
